import { type Address } from "@repo/api";
import { type FC, type ReactElement } from "react";
import InformationList from "../InformationList";
import AddressTemplate from "./AddressTemplate";

export interface AddressBoxProps {
	address?: Address;
	label?: string;
	subLabel?: string;
	isLoading?: boolean;
	editAction?: ReactElement;
}

const AddressBox: FC<AddressBoxProps> = ({
	address,
	label,
	subLabel,
	isLoading,
	editAction,
	...rest
}) => {
	return (
		<InformationList
			isLoading={isLoading}
			information={[
				{
					title: label,
					subTitle: subLabel,
					description: <AddressTemplate address={address} />,
				},
			]}
			secondaryAction={editAction}
			{...rest}
		/>
	);
};

export default AddressBox;
